<template>
  <div class="inventoryPage">
<div class="card-header">
          <a @click="$router.push('/')" class="prevButton backArrow mr-2" data-dismiss="modal">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background:new 0 0 512 512;"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M501.333,245.333H36.417l141.792-141.792c4.167-4.167,4.167-10.917,0-15.083c-4.167-4.167-10.917-4.167-15.083,0l-160,160
              c-4.167,4.167-4.167,10.917,0,15.083l160,160c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125
              c4.167-4.167,4.167-10.917,0-15.083L36.417,266.667h464.917c5.896,0,10.667-4.771,10.667-10.667S507.229,245.333,501.333,245.333z
              "
                  />
                </g>
              </g>
            </svg>
          </a>Home
        </div>
    <div class="container-fluid mt-3">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <h3>{{projectName}}</h3>
              <div class="grid-holder">
                <span class="title">Typology</span>
                <select @change="changeTypology" class="custom-select">
                  <option
                    v-for="typology in typologies"
                    :value="typology.key"
                    :selected="typology.key === selectedTypology.key"
                  >{{typology.value}}</option>
                </select>
              </div>
              <div class="grid-holder">
                <span class="title">Floor Range</span>
                <select @change="changeFloor" class="custom-select">
                  <option
                    v-if="selectedFloor === null"
                    :selected="selectedFloor===null"
                  >Please Select</option>
                  <option
                    v-for="floor in floors"
                    :value="floor.key"
                    :selected="selectedFloor !== null && floor.key === selectedFloor.key"
                  >{{floor.value}}</option>
                </select>
              </div>
              <div class="grid-holder">
                <span class="title">Saleable Area Sqm</span>
                <span class="titleDetails">{{selectedTypology.area}} Sq.Ft.</span>
              </div>
              <div class="grid-holder">
                <span class="title">Price</span>
                <span class="titleDetails">₹ {{selectedTypology.priceRange}} Cr</span>
              </div>
            </div>
            <div class="col-md-9">
              <div class="card-group">
                <div class="">
                  <div>
                    <a data-fancybox="gallery" :href="typologyPlanSrc">
                      <img
                        :src="typologyPlanSrc"
                        :alt="typologyPlanAlt"
                        class="img-fluid rounded border floorPlanImg"
                      />
                    </a>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-md-4">
                      <a
                        class="btn btn-outline-primary"
                        @click="openModal('modal-interior')"
                      >Interior Walkthrough</a>
                    </div>
                    <div class="col-md-4">
                      <a
                        class="btn btn-outline-primary"
                        @click="openModal('modal-video-conf')"
                      >Schedule a Video Conference</a>
                    </div>
                    <div class="col-md-4">
                      <a
                        class="btn btn-outline-primary btn-primary"
                        @click="goToInventory"
                        target="_blank"
                        style="color: #fff; min-width: 180px"
                      >Choose Inventory</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <InteriorWalk />
    <ConfForm />
  </div>
</template>
<script>
import InteriorWalk from "@/components/Plan/InteriorWalk.vue";
import ConfForm from "@/components/Plan/ConfForm.vue";
import { masterJson, projectName } from "@/assets/scripts/utility.js";
export default {
  components: {
    InteriorWalk,
    ConfForm,
  },
  created() {
    let selectedFloor = masterJson.Floors.find(
      (k) => k.key === this.$route.params.floor
    );
    if (selectedFloor) {
      this.$store.dispatch("setFloor", selectedFloor);
    }
    let selectedTypology = masterJson.Typologies.find(
      (k) => k.key === this.$route.params.typology
    );
    if (selectedTypology) {
      this.$store.dispatch("setTypology", selectedTypology);
    }
  },
  methods: {
    openModal(modalName) {
      this.$bvModal.show(modalName);
    },
    changeTypology(event) {
      let selectedTypology = masterJson.Typologies.find(
        (k) => k.key === event.target.value
      );
      this.$store.dispatch("setTypology", selectedTypology);
    },
    changeFloor(event) {
      let selectedFloor = masterJson.Floors.find(
        (k) => k.key === event.target.value
      );
      this.$store.dispatch("setFloor", selectedFloor);
    },
    goToInventory() {
      this.$router.push({
        name: "Inventory",
        params: {
          floor: this.selectedFloor.key,
          typology: this.selectedTypology.key,
        },
      });
    },
  },
  computed: {
    selectedTypology() {
      return this.$store.getters.selectedTypology;
    },
    selectedFloor() {
      return this.$store.getters.selectedFloor;
    },
    projectName() {
      return projectName;
    },
    typologies() {
      return masterJson.Typologies;
    },
    floors() {
      return masterJson.Floors;
    },
    typologyPlanSrc() {
      return require(`@/assets/images/plans/${this.selectedTypology.key}.jpg`);
    },
    typologyPlanAlt() {
      return `${this.selectedTypology.value} Floor Plans`;
    },
  },
};
</script>